import { AfterViewInit, Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core'
import { InlineEditCellNewDirective } from '../inline-edit-cell-new'
import { FormControl } from '@angular/forms'
import { CatalogueEntry } from '@dot-it/jml-lib'
import { MultiSelect } from 'primeng/multiselect'

@Component({
  selector: 'jml-lib-multiselect-cell',
  templateUrl: './multiselect-cell.component.html',
  styleUrls: ['./multiselect-cell.component.scss']
})
export class MultiselectCellComponent extends InlineEditCellNewDirective implements OnChanges {
  @Input() tableReference?: ElementRef
  @Input() options: CatalogueEntry[] = []
  @Input() header = ''
  @Input() showLabel = true
  @Input() showIcon = false
  @Input() showTooltip = false

  @ViewChild('multiselect') multiselect: MultiSelect

  override newValue: FormControl<CatalogueEntry[]>
  selectedEntries: CatalogueEntry[] = []

  private isSaving = false

  ngOnChanges(changes: SimpleChanges) {
    if (changes.value || changes.options) {
      this.initializeValue()
    }
  }

  initializeValue() {
    if (Array.isArray(this.value) && this.options.length > 0) {
      this.selectedEntries = this.value
        .map((v) => this.options.find((option) => option.id === v.id))
        .filter((entry) => !!entry)
    } else {
      this.selectedEntries = []
    }

    this.newValue = new FormControl(this.selectedEntries)
  }

  triggerEdit() {
    this.initializeValue()
    this.isSaving = false

    setTimeout(() => {
      this.isEdited = true
      setTimeout(() => {
        if (this.multiselect) {
          this.multiselect.show()
        }
      }, 50)
    }, 10)

    if (this.tableReference) {
      this.tableReference.nativeElement
        .querySelector('div.p-datatable-scrollable-body')
        ?.addEventListener('scroll', () => this.onPanelClose(), { passive: true, once: true })
    }
  }

  saveAndClose() {
    this.isSaving = true

    if (this.multiselect) {
      this.multiselect.hide()
    }

    this.save()
  }

  onPanelClose() {
    if (!this.isSaving) {
      this.abortCellEdit(null)
    }

    this.isSaving = false
  }

  save() {
    this.isEdited = false
    const ids = this.selectedEntries.map((entry) => entry.id)
    this.completeCellEdit.emit({ value: ids })
  }

  override abortCellEdit(event?: any) {
    this.isEdited = false
    this.initializeValue()
  }

  getDisplayValue(): string {
    if (!Array.isArray(this.value) || this.value.length === 0) {
      return ''
    }

    return this.value.map((v) => v._repr_ || v.name || `ID: ${v.id}`).join(', ')
  }
}
